export function guard<T>(falseCallback: () => void, arg: T): NonNullable<T>;

export function guard<T>(
    falseCallback: () => void,
    ...args: T[]
): { [K in keyof T[]]: NonNullable<T[]>[K] };

export function guard<T, U extends NonNullable<T>[]>(
    falseCallback: () => void,
    ...args: T[]
): U {
    for (const arg of args) {
        if (arg === null || arg === undefined) {
            falseCallback();
        }
    }
    return args as unknown as U;
}
